import {
  FETCH_PRICEBANNER_CONFIG_SUCCESS,
  FETCH_PRICEBANNER_CONFIG_ERROR,
  SAVE_PRICEBANNER_CONFIG_SUCCESS,
  SAVE_PRICEBANNER_CONFIG_ERROR,
  DELETE_PRICEBANNER_CONFIG_ERROR,
} from 'constants/actionTypes'

const DEFAULT_STATE = {
  error: null,
  errorSave: null,
  dataSave: null,
  list: [],
}

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_PRICEBANNER_CONFIG_SUCCESS:
      return {
        ...state,
        error: null,
        list: action.payload,
      }
    case SAVE_PRICEBANNER_CONFIG_SUCCESS:
      return {
        ...state,
        dataSave: action.payload,
        errorSave: null,
      }
    case SAVE_PRICEBANNER_CONFIG_ERROR:
      return {
        ...state,
        dataSave: null,
        errorSave: action.payload,
      }
    case FETCH_PRICEBANNER_CONFIG_ERROR:
    case DELETE_PRICEBANNER_CONFIG_ERROR:
      return {
        ...state,
        error: action.payload,
      }
    default:
      return {
        ...state,
        errorSave: null,
        dataSave: null,
      }
  }
}
